import { IconEye as TablerIconEye } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconEye = /*#__PURE__*/ createOutlineIcon(TablerIconEye, 'IconEye');
